import { render } from "./MwcView.vue?vue&type=template&id=e8da20f0"
import script from "./MwcView.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./MwcView.vue?vue&type=script&charset=utf-8&lang=js"

import "./MwcView.vue?vue&type=style&index=0&id=e8da20f0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__